import type { sectionsConfigElem } from "../store/slices/app.slice";

/*
	Читает и нормализует sectionsConfig из localStorage без перезаписи файла 
	для схоранени пропорций и расположения окон, которые выставил пользователь
*/
const pickSectionName = (item: Record<string, unknown>): string => {
	const a = item.sectionName;
	const b = item.section_name;
	if (typeof a === "string" && a.trim()) return a.trim();
	if (typeof b === "string" && b.trim()) return b.trim();
	return "";
};

const pickSectionWeightRaw = (
	item: Record<string, unknown>,
): string | number | undefined => {
	const a = item.sectionWeight;
	const b = item.section_weight;
	if (a !== undefined && a !== null && a !== "") return a as string | number;
	if (b !== undefined && b !== null && b !== "") return b as string | number;
	return undefined;
};

export const readStoredSectionsConfig = (): sectionsConfigElem[] | null => {
	if (typeof window === "undefined") return null;
	try {
		const raw = localStorage.getItem("sectionsConfig");
		if (!raw) return null;
		const parsed = JSON.parse(raw) as unknown;
		if (!Array.isArray(parsed) || parsed.length === 0) return null;

		const normalized = parsed
			.map((item): sectionsConfigElem | null => {
				if (!item || typeof item !== "object") return null;
				const o = item as Record<string, unknown>;
				const sectionName = pickSectionName(o);
				if (!sectionName) return null;

				const rawW = pickSectionWeightRaw(o);
				const fallback =
					rawW === undefined || rawW === null || rawW === "" ? 1 : Number(rawW);
				const sectionWeight = Number.isFinite(fallback) ? fallback : Number.NaN;
				if (Number.isNaN(sectionWeight)) return null;

				return { sectionName, sectionWeight };
			})
			.filter((x): x is sectionsConfigElem => x !== null);

		return normalized.length > 0 ? normalized : null;
	} catch {
		return null;
	}
};
